
export const listContatos = [
  { id: "tel", link: "tel:+552139006975", name: "(021) 3900-6975" },
  { id: "email", link: "mailto:contato@planiumbank.com.br", name: "contato@planiumbank.com.br" },
]